import styled, { css } from 'styled-components';
import { COLORS, SafeHtml, WarningMessage, media } from 'ia-react-core';

export const StyledMessageBox = styled.div<{ withSeparator: boolean }>`
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern";
    font-kerning: normal;
    line-height: normal;
    color: ${COLORS.BLACK};
    margin-right: 16px;
    padding-bottom: 24px;
    padding-top: 16px;

    ${media.sm`
      padding-top: 24px;
    `};

    &:first-of-type {
      padding-top: 4px;
      ${media.sm`
        padding-top: 24px;
      `};
    }


    ${({ withSeparator }) => withSeparator && css`
        border-top: 1px solid #ef6d19;
    `}

    p {
        margin-block-end: 0px;
        margin-block-start: 0px;
        margin: 0px;
        margin-inline-end: 0px;
        margin-inline-start: 0px;
    }
`;

export const StyledWarningMessage = styled(WarningMessage)`
 
  padding-top: 24px;
  padding-bottom: 0;
  ${media.sm`
    padding-top: 0;
  `};
`;

export const StyledTitle = styled.h1`
  font-size: 17px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 8px;
`;

export const StyledSafeHtml = styled(SafeHtml)`
  font-weight: 600;
`;
